module.exports = __webpack_public_path__ + "media/assets/img/products/studio_unilingual-unavailable-15eb2c61c36f1a016302d078e0022444.svg";